// Team Insights — Playlist Matcher strings (prefix `ins.plm.`)
const en = {
  "ins.plm.title": "Playlist Matcher",
  "ins.plm.subtitle": "Find playlists in our curated database that fit your release — and what to improve before you pitch.",
  "ins.plm.pickTitle": "Choose a release",
  "ins.plm.pickDesc": "We compare its genre, language and details with the playlists in our curated database.",
  "ins.plm.noReleases": "No eligible releases yet",
  "ins.plm.noReleasesDesc": "Submit a release first — drafts can't be analysed.",
  "ins.plm.createRelease": "Create a release",
  "ins.plm.untitled": "Untitled",
  "ins.plm.noGenre": "No genre",
  "ins.plm.status.submitted": "Submitted",
  "ins.plm.status.approved": "Approved",
  "ins.plm.status.live": "Live",
  "ins.plm.status.pending": "Pending",
  "ins.plm.status.processing": "Processing",
  "ins.plm.status.scheduled": "Scheduled",
  "ins.plm.status.distributed": "Distributed",
  "ins.plm.savedNote": "Each analysis is saved to your history.",
  "ins.plm.analyze": "Find matching playlists",
  "ins.plm.analyzing": "Comparing your release with our playlists…",
  "ins.plm.analyzingDesc": "Checking genre, language and release details. This usually takes a few seconds.",
  "ins.plm.done": "Analysis complete",
  "ins.plm.failed": "The analysis couldn't be completed. Please try again.",
  "ins.plm.loadError": "We couldn't load your releases.",
  "ins.plm.analyzedAt": "Analysed {date}",
  "ins.plm.scanned": "{n} playlists scanned",
  "ins.plm.viewRelease": "View release",
  "ins.plm.newAnalysis": "New analysis",
  "ins.plm.legacyNote": "This analysis was made with the previous matcher, which didn't read release genres correctly. Run a new analysis for more accurate results.",
  "ins.plm.readiness": "Metadata readiness",
  "ins.plm.check.genre": "Primary genre",
  "ins.plm.check.subgenre": "Secondary genre",
  "ins.plm.check.language": "Language",
  "ins.plm.check.cover": "Cover art",
  "ins.plm.check.tracks": "At least one track",
  "ins.plm.check.artist": "Artist name",
  "ins.plm.done.short": "done",
  "ins.plm.missing": "missing",
  "ins.plm.potential": "Match potential",
  "ins.plm.potentialInfo": "60% average fit of your top matching playlists + 40% metadata readiness. It's a guide, not a prediction of acceptance or streams.",
  "ins.plm.matchedOf": "{m} matching of {n} scanned",
  "ins.plm.noMatchShort": "No matching playlists yet",
  "ins.plm.genreUsed": "Genre used",
  "ins.plm.timing": "Release timing",
  "ins.plm.releaseDate": "Release date",
  "ins.plm.daysUntil": "In {n} day(s)",
  "ins.plm.today": "Today",
  "ins.plm.released": "Already released",
  "ins.plm.isFriday": "Friday release — aligned with New Music Friday.",
  "ins.plm.notFriday": "Not a Friday. Most new music is released on Fridays.",
  "ins.plm.fridayGeneral": "Most new music is released on Fridays at 00:00 local time, when editorial playlists refresh.",
  "ins.plm.playlists": "Matching playlists",
  "ins.plm.explore": "Browse all playlists",
  "ins.plm.noMatches": "No matching playlists yet",
  "ins.plm.noMatchesDesc": "None of the {n} playlists in our database fit this release's genre or language. We only show playlists that are actually relevant.",
  "ins.plm.fit": "Fit",
  "ins.plm.open": "Open {name}",
  "ins.plm.reason.genre_exact": "Same genre",
  "ins.plm.reason.genre_similar": "Similar genre",
  "ins.plm.reason.genre_related": "Related genre",
  "ins.plm.reason.keywords": "Keyword match",
  "ins.plm.reason.language": "Language match",
  "ins.plm.reason.mood": "Mood match",
  "ins.plm.reason.popular": "Large audience",
  "ins.plm.reason.verified": "Verified playlist",
  "ins.plm.pitchCta": "Ready to pitch? Start a playlist campaign for this release.",
  "ins.plm.startCampaign": "Start a campaign",
  "ins.plm.tips": "Next steps",
  "ins.plm.tip.add_genre": "Add a primary genre to your release — it's the strongest matching signal.",
  "ins.plm.tip.add_subgenre": "Add a secondary genre for more precise matches.",
  "ins.plm.tip.add_language": "Set the release language so language-based playlists can match.",
  "ins.plm.tip.add_cover": "Upload high-resolution cover art — curators see it first.",
  "ins.plm.tip.add_tracks": "Add at least one track to the release.",
  "ins.plm.tip.add_artist": "Add the primary artist name.",
  "ins.plm.tip.complete_metadata": "Complete your release details for more accurate matches.",
  "ins.plm.tip.top_match": "\"{name}\" is a strong fit — pitch to it first.",
  "ins.plm.tip.no_matches": "No playlist in our database fits this release yet. New playlists are added regularly — try again later or browse the Playlist Explorer.",
  "ins.plm.tip.pitch_window": "Your release is {days} day(s) away — pitch to curators now, ideally at least 7 days before release.",
  "ins.plm.tip.pitch_early": "For your next release, pitch to curators at least 7 days before release day.",
  "ins.plm.tip.friday": "Your release date isn't a Friday. Most new music comes out on Fridays, when editorial playlists refresh.",
  "ins.plm.history": "Past analyses",
  "ins.plm.noHistory": "Your analyses will appear here.",
  "ins.plm.matchesN": "{n} matches",
};

const tr = {
  "ins.plm.title": "Playlist Eşleştirici",
  "ins.plm.subtitle": "Seçilmiş playlist veritabanımızda yayınınıza uyan playlist'leri ve başvurmadan önce neleri iyileştirmeniz gerektiğini bulun.",
  "ins.plm.pickTitle": "Bir yayın seçin",
  "ins.plm.pickDesc": "Yayının türünü, dilini ve bilgilerini veritabanımızdaki playlist'lerle karşılaştırırız.",
  "ins.plm.noReleases": "Henüz uygun yayın yok",
  "ins.plm.noReleasesDesc": "Önce bir yayın gönderin — taslaklar analiz edilemez.",
  "ins.plm.createRelease": "Yayın oluştur",
  "ins.plm.untitled": "Adsız",
  "ins.plm.noGenre": "Tür yok",
  "ins.plm.status.submitted": "Gönderildi",
  "ins.plm.status.approved": "Onaylandı",
  "ins.plm.status.live": "Yayında",
  "ins.plm.status.pending": "Beklemede",
  "ins.plm.status.processing": "İşleniyor",
  "ins.plm.status.scheduled": "Planlandı",
  "ins.plm.status.distributed": "Dağıtıldı",
  "ins.plm.savedNote": "Her analiz geçmişinize kaydedilir.",
  "ins.plm.analyze": "Uyan playlist'leri bul",
  "ins.plm.analyzing": "Yayınınız playlist'lerimizle karşılaştırılıyor…",
  "ins.plm.analyzingDesc": "Tür, dil ve yayın bilgileri kontrol ediliyor. Bu genellikle birkaç saniye sürer.",
  "ins.plm.done": "Analiz tamamlandı",
  "ins.plm.failed": "Analiz tamamlanamadı. Lütfen tekrar deneyin.",
  "ins.plm.loadError": "Yayınlarınız yüklenemedi.",
  "ins.plm.analyzedAt": "Analiz: {date}",
  "ins.plm.scanned": "{n} playlist tarandı",
  "ins.plm.viewRelease": "Yayını görüntüle",
  "ins.plm.newAnalysis": "Yeni analiz",
  "ins.plm.legacyNote": "Bu analiz, yayın türlerini doğru okumayan önceki eşleştirici ile yapıldı. Daha doğru sonuçlar için yeni bir analiz başlatın.",
  "ins.plm.readiness": "Bilgi eksiksizliği",
  "ins.plm.check.genre": "Ana tür",
  "ins.plm.check.subgenre": "İkincil tür",
  "ins.plm.check.language": "Dil",
  "ins.plm.check.cover": "Kapak görseli",
  "ins.plm.check.tracks": "En az bir parça",
  "ins.plm.check.artist": "Sanatçı adı",
  "ins.plm.done.short": "tamam",
  "ins.plm.missing": "eksik",
  "ins.plm.potential": "Eşleşme potansiyeli",
  "ins.plm.potentialInfo": "En iyi eşleşen playlist'lerin ortalama uyumunun %60'ı + bilgi eksiksizliğinin %40'ı. Kabul veya dinlenme tahmini değil, bir rehberdir.",
  "ins.plm.matchedOf": "{n} taranan playlist'ten {m} eşleşme",
  "ins.plm.noMatchShort": "Henüz eşleşen playlist yok",
  "ins.plm.genreUsed": "Kullanılan tür",
  "ins.plm.timing": "Yayın zamanlaması",
  "ins.plm.releaseDate": "Yayın tarihi",
  "ins.plm.daysUntil": "{n} gün sonra",
  "ins.plm.today": "Bugün",
  "ins.plm.released": "Yayınlandı",
  "ins.plm.isFriday": "Cuma yayını — New Music Friday ile uyumlu.",
  "ins.plm.notFriday": "Cuma değil. Yeni müziklerin çoğu cuma günü yayınlanır.",
  "ins.plm.fridayGeneral": "Yeni müziklerin çoğu, editoryal playlist'lerin yenilendiği cuma günü yerel saatle 00:00'da yayınlanır.",
  "ins.plm.playlists": "Eşleşen playlist'ler",
  "ins.plm.explore": "Tüm playlist'lere göz at",
  "ins.plm.noMatches": "Henüz eşleşen playlist yok",
  "ins.plm.noMatchesDesc": "Veritabanımızdaki {n} playlist'in hiçbiri bu yayının türüne veya diline uymuyor. Yalnızca gerçekten ilgili playlist'leri gösteriyoruz.",
  "ins.plm.fit": "Uyum",
  "ins.plm.open": "{name} playlist'ini aç",
  "ins.plm.reason.genre_exact": "Aynı tür",
  "ins.plm.reason.genre_similar": "Benzer tür",
  "ins.plm.reason.genre_related": "İlişkili tür",
  "ins.plm.reason.keywords": "Anahtar kelime eşleşmesi",
  "ins.plm.reason.language": "Dil eşleşmesi",
  "ins.plm.reason.mood": "Mood eşleşmesi",
  "ins.plm.reason.popular": "Geniş kitle",
  "ins.plm.reason.verified": "Doğrulanmış playlist",
  "ins.plm.pitchCta": "Başvurmaya hazır mısınız? Bu yayın için bir playlist kampanyası başlatın.",
  "ins.plm.startCampaign": "Kampanya başlat",
  "ins.plm.tips": "Sonraki adımlar",
  "ins.plm.tip.add_genre": "Yayınınıza ana tür ekleyin — en güçlü eşleştirme sinyalidir.",
  "ins.plm.tip.add_subgenre": "Daha isabetli eşleşmeler için ikincil tür ekleyin.",
  "ins.plm.tip.add_language": "Dile göre playlist'lerin eşleşebilmesi için yayın dilini belirtin.",
  "ins.plm.tip.add_cover": "Yüksek çözünürlüklü bir kapak yükleyin — küratörlerin ilk gördüğü şeydir.",
  "ins.plm.tip.add_tracks": "Yayına en az bir parça ekleyin.",
  "ins.plm.tip.add_artist": "Ana sanatçı adını ekleyin.",
  "ins.plm.tip.complete_metadata": "Daha doğru eşleşmeler için yayın bilgilerinizi tamamlayın.",
  "ins.plm.tip.top_match": "\"{name}\" çok uygun — önce bu playlist'e başvurun.",
  "ins.plm.tip.no_matches": "Veritabanımızda henüz bu yayına uyan bir playlist yok. Düzenli olarak yeni playlist'ler ekleniyor — daha sonra tekrar deneyin veya Playlist Keşfet'e göz atın.",
  "ins.plm.tip.pitch_window": "Yayınınıza {days} gün var — küratörlere şimdi, ideal olarak yayından en az 7 gün önce başvurun.",
  "ins.plm.tip.pitch_early": "Bir sonraki yayınınızda küratörlere yayın gününden en az 7 gün önce başvurun.",
  "ins.plm.tip.friday": "Yayın tarihiniz cuma değil. Yeni müziklerin çoğu, editoryal playlist'lerin yenilendiği cuma günü çıkar.",
  "ins.plm.history": "Geçmiş analizler",
  "ins.plm.noHistory": "Analizleriniz burada görünecek.",
  "ins.plm.matchesN": "{n} eşleşme",
};

const es = {
  "ins.plm.title": "Buscador de Playlists",
  "ins.plm.subtitle": "Encuentra playlists de nuestra base de datos que encajan con tu lanzamiento, y qué mejorar antes de enviarlo.",
  "ins.plm.pickTitle": "Elige un lanzamiento",
  "ins.plm.pickDesc": "Comparamos su género, idioma y datos con las playlists de nuestra base de datos.",
  "ins.plm.noReleases": "Aún no hay lanzamientos elegibles",
  "ins.plm.noReleasesDesc": "Envía primero un lanzamiento: los borradores no se pueden analizar.",
  "ins.plm.createRelease": "Crear un lanzamiento",
  "ins.plm.untitled": "Sin título",
  "ins.plm.noGenre": "Sin género",
  "ins.plm.status.submitted": "Enviado",
  "ins.plm.status.approved": "Aprobado",
  "ins.plm.status.live": "Publicado",
  "ins.plm.status.pending": "Pendiente",
  "ins.plm.status.processing": "Procesando",
  "ins.plm.status.scheduled": "Programado",
  "ins.plm.status.distributed": "Distribuido",
  "ins.plm.savedNote": "Cada análisis se guarda en tu historial.",
  "ins.plm.analyze": "Buscar playlists compatibles",
  "ins.plm.analyzing": "Comparando tu lanzamiento con nuestras playlists…",
  "ins.plm.analyzingDesc": "Revisando género, idioma y datos del lanzamiento. Suele tardar unos segundos.",
  "ins.plm.done": "Análisis completado",
  "ins.plm.failed": "No se pudo completar el análisis. Inténtalo de nuevo.",
  "ins.plm.loadError": "No pudimos cargar tus lanzamientos.",
  "ins.plm.analyzedAt": "Analizado el {date}",
  "ins.plm.scanned": "{n} playlists analizadas",
  "ins.plm.viewRelease": "Ver lanzamiento",
  "ins.plm.newAnalysis": "Nuevo análisis",
  "ins.plm.legacyNote": "Este análisis se hizo con el buscador anterior, que no leía bien los géneros del lanzamiento. Haz un nuevo análisis para obtener resultados más precisos.",
  "ins.plm.readiness": "Datos completos",
  "ins.plm.check.genre": "Género principal",
  "ins.plm.check.subgenre": "Género secundario",
  "ins.plm.check.language": "Idioma",
  "ins.plm.check.cover": "Portada",
  "ins.plm.check.tracks": "Al menos una pista",
  "ins.plm.check.artist": "Nombre del artista",
  "ins.plm.done.short": "hecho",
  "ins.plm.missing": "falta",
  "ins.plm.potential": "Potencial de coincidencia",
  "ins.plm.potentialInfo": "60 % del ajuste medio de tus playlists más compatibles + 40 % de datos completos. Es una guía, no una predicción de aceptación ni de reproducciones.",
  "ins.plm.matchedOf": "{m} compatibles de {n} analizadas",
  "ins.plm.noMatchShort": "Aún no hay playlists compatibles",
  "ins.plm.genreUsed": "Género usado",
  "ins.plm.timing": "Momento del lanzamiento",
  "ins.plm.releaseDate": "Fecha de lanzamiento",
  "ins.plm.daysUntil": "En {n} día(s)",
  "ins.plm.today": "Hoy",
  "ins.plm.released": "Ya publicado",
  "ins.plm.isFriday": "Lanzamiento en viernes: alineado con New Music Friday.",
  "ins.plm.notFriday": "No es viernes. La mayoría de la música nueva se publica los viernes.",
  "ins.plm.fridayGeneral": "La mayoría de la música nueva se publica los viernes a las 00:00 hora local, cuando se actualizan las playlists editoriales.",
  "ins.plm.playlists": "Playlists compatibles",
  "ins.plm.explore": "Ver todas las playlists",
  "ins.plm.noMatches": "Aún no hay playlists compatibles",
  "ins.plm.noMatchesDesc": "Ninguna de las {n} playlists de nuestra base de datos encaja con el género o el idioma de este lanzamiento. Solo mostramos playlists realmente relevantes.",
  "ins.plm.fit": "Ajuste",
  "ins.plm.open": "Abrir {name}",
  "ins.plm.reason.genre_exact": "Mismo género",
  "ins.plm.reason.genre_similar": "Género similar",
  "ins.plm.reason.genre_related": "Género relacionado",
  "ins.plm.reason.keywords": "Palabras clave",
  "ins.plm.reason.language": "Mismo idioma",
  "ins.plm.reason.mood": "Mismo ambiente",
  "ins.plm.reason.popular": "Gran audiencia",
  "ins.plm.reason.verified": "Playlist verificada",
  "ins.plm.pitchCta": "¿Listo para enviarlo? Inicia una campaña de playlists para este lanzamiento.",
  "ins.plm.startCampaign": "Iniciar campaña",
  "ins.plm.tips": "Próximos pasos",
  "ins.plm.tip.add_genre": "Añade un género principal a tu lanzamiento: es la señal de coincidencia más fuerte.",
  "ins.plm.tip.add_subgenre": "Añade un género secundario para coincidencias más precisas.",
  "ins.plm.tip.add_language": "Indica el idioma del lanzamiento para que coincidan las playlists por idioma.",
  "ins.plm.tip.add_cover": "Sube una portada en alta resolución: es lo primero que ven los curadores.",
  "ins.plm.tip.add_tracks": "Añade al menos una pista al lanzamiento.",
  "ins.plm.tip.add_artist": "Añade el nombre del artista principal.",
  "ins.plm.tip.complete_metadata": "Completa los datos de tu lanzamiento para obtener coincidencias más precisas.",
  "ins.plm.tip.top_match": "\"{name}\" encaja muy bien: envíalo ahí primero.",
  "ins.plm.tip.no_matches": "Todavía no hay ninguna playlist en nuestra base de datos que encaje con este lanzamiento. Añadimos playlists con regularidad: vuelve a intentarlo más tarde o explora el Explorador de Playlists.",
  "ins.plm.tip.pitch_window": "Faltan {days} día(s) para tu lanzamiento: envíalo a los curadores ahora, idealmente al menos 7 días antes.",
  "ins.plm.tip.pitch_early": "En tu próximo lanzamiento, envíalo a los curadores al menos 7 días antes.",
  "ins.plm.tip.friday": "Tu fecha de lanzamiento no es viernes. La mayoría de la música nueva sale los viernes, cuando se actualizan las playlists editoriales.",
  "ins.plm.history": "Análisis anteriores",
  "ins.plm.noHistory": "Tus análisis aparecerán aquí.",
  "ins.plm.matchesN": "{n} coincidencias",
};

export default { en, tr, es };
